import * as React from 'react';
import Image from '../../../../components/image';
import { ImageTransformation, ZoomedImage } from '../../../../types';
import CloseIcon from '../../../../../../svg/icons/remove.svg';

interface ZoomerProps {
  zoomedImage: ZoomedImage;
  setZoomedImage: React.Dispatch<React.SetStateAction<ZoomedImage | undefined>>;
  viewerMaxPercentage: number;
}

function Zoomer({ zoomedImage, setZoomedImage, viewerMaxPercentage }: ZoomerProps): React.ReactElement | null {
  const zoomedImageHeight = (zoomedImage.height * viewerMaxPercentage) / 100;

  React.useEffect(() => {
    const meta = document.head.querySelector("meta[name ='viewport']");
    disableViewportZoom(meta);

    return (): void => {
      enableViewportZoom(meta);
    };
  }, []);

  function disableViewportZoom(meta: Element | null): void {
    meta?.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=0');
    document.body.style.overflow = 'hidden';
  }

  function enableViewportZoom(meta: Element | null): void {
    meta?.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=1');
    document.body.style.overflow = 'initial';
  }

  const setZoomedImageToCenter = (): void => {
    const zoomerContainer = document.querySelector('.zoomer__container');
    const zoomerImage = document.querySelector('.zoomer__image');

    if (zoomerContainer && zoomerImage) {
      zoomerContainer.scrollLeft = zoomerImage.clientWidth / 2 - zoomerContainer.clientWidth * 0.5;
      zoomerContainer.scrollTop = zoomerImage.clientHeight / 2 - zoomerContainer.clientHeight * 0.5;
    }
  };

  return (
    <div className="zoomer">
      <div className="zoomer__container">
        <button className="zoomer__close-button" type="button" onClick={(): void => setZoomedImage(undefined)}>
          <CloseIcon />
        </button>
        <Image
          src={zoomedImage.src}
          className="zoomer__image"
          style={{ height: zoomedImageHeight }}
          onLoad={setZoomedImageToCenter}
          transformationTemplates={{
            1: ImageTransformation.LOUPDP_L,
            2: ImageTransformation.LOUPDP_L_R
          }}
        />
      </div>
    </div>
  );
}

export default Zoomer;
